import React from 'react';

/* Figma asset: ListItem - label + value row
   layout: 'spread' (justify-between), 'inline' (fixed label width), 'admin' (admin detail compact) */
export default function ListItem({ label, value, extra, bold, layout = 'spread', className = '' }) {
  const isInline = layout === 'inline';
  const isAdmin = layout === 'admin';
  return (
    <div className={`flex ${isAdmin ? 'items-baseline gap-0' : isInline ? 'items-center gap-4 sm:gap-6' : 'items-center justify-between'} py-1.5 ${className}`}>
      <span className={`text-2sm font-medium text-mono-500 ${isAdmin ? 'w-[100px] shrink-0' : isInline ? 'w-[96px] sm:w-[120px] shrink-0 whitespace-nowrap' : ''}`}>
        {label}
      </span>
      <span className={`text-2sm ${bold ? 'font-bold' : 'font-medium'} text-mono-900 ${isAdmin ? 'min-w-0 break-all' : isInline ? 'min-w-0 break-words' : ''}`}>{value}</span>
      {extra && <span className="text-2sm font-normal text-mono-400 ml-1">{extra}</span>}
    </div>
  );
}
